import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { menuItems } from "../lib/FakeData";
import Navitem from "./NavItem";
import { RiFacebookBoxLine, RiTwitterXFill } from "react-icons/ri";
import { FaFacebookF, FaInstagram, FaPinterestP, FaXTwitter } from "react-icons/fa6";
import { useSelector } from "react-redux";

export const Sidebar = ({ open, setOpen }) => {
    const categoryList = useSelector((state) => state.categoryList);
    const { loading: loadingList, error: errorList, categories } = categoryList;
    // console.log("categoriescategories ", categories);

    return (
        <div className="relative">

            <div
                onClick={() => setOpen(false)}
                className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 ${open ? "opacity-100 visible" : "opacity-0 invisible"
                    }`}
            ></div>

            {/* Sidebar */}
            <div
                className={`fixed top-0 left-0 h-full w-[80%] md:w-72 bg-white shadow-lg z-50  
        transform transition-transform duration-300 ease-in-out
        ${open ? "translate-x-0" : "-translate-x-full"}`}
            >
                <div className="flex items-center justify-between py-2 px-4 border-b bg-[--color-button-3] h-[50px]">
                    {/* <h2 className="text-lg font-bold text-white">Sidebar</h2> */}
                    <button onClick={() => setOpen(false)}>
                        <IoClose size={24} className="text-white" />
                    </button>
                </div>

                <nav className="p-4 flex flex-col gap-2 overflow-scroll h-[calc(100vh-150px)]">

                    <Navitem item={{
                        value: 1,
                        isMega: true,
                        label: "Mua sắm theo danh mục",
                        childrens: categories ? categories?.map((value) => {
                            return {
                                value: value._id,
                                label: value.name,
                                href: `/category/${value._id}`
                            }
                        }) : [],
                    }} onClick={() => setOpen(false)} />
                    {menuItems && menuItems?.map((value, index) => {
                        return <Navitem key={index} item={value} onClick={() => setOpen(false)} />
                    })}

                </nav>

                <div className="flex flex-col  py-4 px-4 border-b   bottom-0 gap-4 bg-white w-full h-[100px] ">
                    {/* <div className="flex gap-2">
                        <button className="bg-[--color-button-3] w-auto px-4 py-2 rounded-full text-white text-sm font-bold">
                            Compare (0)
                        </button>
                        <button className="bg-[--color-button-3] w-auto px-4 py-2 rounded-full text-white  text-sm font-bold">
                            Compare (0)
                        </button>
                    </div> */}
                    <div className="flex items-center  gap-6">
                        <button>
                            <FaXTwitter />
                        </button>
                        <button>
                            <FaFacebookF />
                        </button>
                        <button>
                            <FaPinterestP />
                        </button>
                        <button>
                            <FaInstagram />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
